import {Inline} from "../components/Table/TableBody/TableRow/TableCell";

export const preparePrice = (price) => {
  const priceNumber = Number(price);

  if (isNaN(priceNumber)) return price;

  return <Inline>{priceNumber.toLocaleString('ru') + ' ₽'}</Inline>;
};